window.Leaderboards = new function()
{
    this.vars = {
        grid: false,
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('body').imagesLoaded( function() {
          Leaderboards.vars.grid = jQuery('.leaderboard-panels').isotope({
            itemSelector: '.leaderboard-panel',
            layoutMode: 'masonry'
          });
        });

        jQuery('body').on('change', '.leaderboard-panel .toolbar select', function(event) {
            event.preventDefault();
            
            Leaderboards.sort(this);
        });

        jQuery('body').on('change', 'select[name="nsfw_filter"]', function(event) {
            event.preventDefault();
            jQuery(this).closest('form').submit();
        });
    };

    /**
     * Change sort of a leaderboard list
     *
     * @param obj el - the select box changed
     */
    this.sort = function(el) {
        var name      = jQuery(el).attr('name');
        var sort      = jQuery(el).find('option:selected').val();
        var sort_name = jQuery(el).find('option:selected').text();
        var url       = '/explore/leaderboards/sort/' + name;

        $.ajax({
            url: url,
            type: 'POST',
            data: {
                sort: sort,
                nsfw_filter: Leaderboards.getParameterByName('nsfw_filter'),
                _token: Leaderboards.vars.token
            },
            showloader: true,
            success: function(response) { 
                jQuery('.' + name + '-tbody').html(response);
                jQuery('.' + name + '-sort-type').text(sort_name);

                Leaderboards.vars.grid.isotope('layout');
            }
        });
    };

    /**
     * Gets a query string param via JS
     *
     * @param string name - param Name
     * @param string url - optional url, defaults to current page
     */
    this.getParameterByName = function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };
}

jQuery(document).ready(function($) {
    Leaderboards.init();
});
